import { I18nComponente } from "@/types/gerais"

export const ListarDeProfissionaisi18n: I18nComponente = {
  "pt-BR": {
    profissionais: "profissionais",
    categorias: "categorias",
    umProfissionalRepresentaUmColaborador: "um profissional representa um colaborador que registra atividades"
  },
  "es-CO": {
    profissionais: "profesionales",
    categorias: "categorías",
    umProfissionalRepresentaUmColaborador: "un profesional representa un empleado que registra actividades"
  }
}
